import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Resell({ outline, ...props }: IconProps): JSX.Element {
  // Default to Solid - no Outline variant needed
  return outline ? <Resell.Solid {...props} /> : <Resell.Solid {...props} />;
}

Resell.Outline = Resell; // Alias to default

Resell.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/* Top arrow - clockwise refresh */}
        <path
          d="M21 12C21 7.02944 16.9706 3 12 3C9.17273 3 6.64921 4.30367 5 6.34267"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M5 3V7H9"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        {/* Bottom arrow - clockwise refresh */}
        <path
          d="M3 12C3 16.9706 7.02944 21 12 21C14.8273 21 17.3508 19.6963 19 17.6573"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M19 21V17H15"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
